"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFormHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = require("../Button");
const CreateFormHeader = ({ onCreatePress, isCreating, fullWidth, label }) => {
    const sizeClass = fullWidth ? "" : "justify-content-end";
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", { className: `d-flex ${sizeClass}`, children: (0, jsx_runtime_1.jsx)("div", { className: `pb-2 ${fullWidth ? "w-100" : ''}`, children: (0, jsx_runtime_1.jsx)(Button_1.Button, { color: "success", onPress: onCreatePress, disabled: isCreating, children: label !== null && label !== void 0 ? label : (isCreating ? "Přidávání..." : "Přidat a uložit") }) }) }) }));
};
exports.CreateFormHeader = CreateFormHeader;
